const getInitialValues = (data, defaultValue = []) => {
  const initialValues = Object.keys(data)
    .filter(key => Boolean(data[key]))

  return initialValues.length !== 0 ? initialValues : defaultValue
}

export const getCommunicationPreferencesFormInitialValues = (appointmentReminder, savingAndDiscounts) => ({
  reminders: getInitialValues(appointmentReminder),
  promotions: getInitialValues(savingAndDiscounts)
})
